import { WebSocketMessageType } from "../../Enums/WebSocketMessageType";

export class MessageWebSocket{
    public Type?: WebSocketMessageType;
    public SessionId?: string;

    constructor(){

    }
}